import { render, staticRenderFns } from "./AgeTable.vue?vue&type=template&id=973ed6be&"
import script from "./AgeTable.vue?vue&type=script&lang=js&"
export * from "./AgeTable.vue?vue&type=script&lang=js&"
import style0 from "./AgeTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports